import { render, staticRenderFns } from "./UserListaCapacitaciones.vue?vue&type=template&id=27102e10&scoped=true"
import script from "./UserListaCapacitaciones.vue?vue&type=script&lang=js"
export * from "./UserListaCapacitaciones.vue?vue&type=script&lang=js"
import style0 from "./UserListaCapacitaciones.vue?vue&type=style&index=0&id=27102e10&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27102e10",
  null
  
)

export default component.exports